<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <div class="content-title content-mb-14">
      <template v-if="project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1">
        <span
          v-if="
            $parent.project.UF_DIRECTION_FINANCING_ID > 0 &&
              project.UF_SETTING.IS_MOB_BUILDING_STRUCTURES == 1
          "
          >{{ 15 + okpoShift + mobOkpdShift }}.</span
        >
        <span v-else-if="project.UF_DIRECTION_FINANCING_ID > 0"
          >{{ 16 + okpoShift + mobOkpdShift }}.</span
        >
        <span v-else>{{ 15 + okpoShift + mobOkpdShift }}.</span>
      </template>
      <span v-else>{{ 14 + okpoShift + mobOkpdShift }}.</span>
      Предполагаемое обеспечение по возврату займа
      <a
        v-if="
          $parent.currentUser.ACTIVE_ROLE == 8 ||
            $parent.currentUser.ACTIVE_ROLE == 24
        "
        @click="$parent.startThirdScenariy"
        class="screenplay-start screenplay-start-resume screenplay-start-resume-banking-security"
      />
    </div>
    <div class="row myrow content-mb-42" v-if="loaded">
      <div class="col-xs-12 mycol">
        <table class="co-executor">
          <tbody>
            <template
              v-for="cfs in directory.sp_criteria_financial_stability"
              v-if="cfs.SORT != 30"
            >
              <tr>
                <td style="padding-top: 20px">{{ cfs.NAME }}</td>
                <td></td>
                <td style="padding-top: 20px">{{ cfs.NAME_DEPENDENCE }}</td>
                <td style="padding-top: 20px">
                  Значение критерия фин. состояния
                </td>
                <td></td>
              </tr>
              <tr
                v-for="item in project.CRITERIA_FINANCIAL_STABILITY.items"
                v-if="cfs.ID === item.UF_CRT_FINANCIAL_ID"
              >
                <td style="width: 290px">
                  <input type="hidden" v-model="item.ID" />
                  <input
                    class="i-main-style tab-wid-280"
                    type="text"
                    @keyup="calcCFS(item)"
                    v-model="item.UF_CRT_FINANCIAL_VAL"
                    :disabled="$parent.$parent.$parent.projectDisabled"
                  />
                </td>
                <td style="width: 10px">/</td>
                <td style="width: 290px">
                  <input
                    class="i-main-style tab-wid-280"
                    type="text"
                    @keyup="calcCFS(item)"
                    v-model="item.UF_DEPENDENCE_VAL"
                    :disabled="
                      $parent.$parent.$parent.projectDisabled ||
                        cfs.IS_DEPENDENCE_ZAIM === 1
                    "
                  />
                </td>
                <td style="width: 290px">
                  <input
                    class="i-main-style tab-wid-280"
                    type="text"
                    v-model="item.UF_CRT_FINANCIAL_TTL"
                    disabled
                  />
                </td>
                <td style="color:red">
                  {{ showCFSError(item, cfs) }}
                </td>
              </tr>
              <tr style="border-bottom: none" v-if="cfs.HELP">
                <td colspan="4" style="padding-top: 2px; font-size: 12px;">
                  {{ cfs.HELP }}
                </td>
              </tr>
            </template>
            <tr style="border-bottom: none">
              <td colspan="4" style="padding: 0">
                Отсутствие существенных (более 15%) отрицательных изменений в
                динамике следующих показателей: выручка от реализации, прибыль
                от продаж, валюта баланса*
                <label class="switch">
                  <input type="checkbox" v-model="project.UF_IS_NOT_NEGATIVE" />
                  <span class="slider round"></span>
                </label>
              </td>
              <td style="color:red;padding: 0">
                <span v-if="!project.UF_IS_NOT_NEGATIVE"
                  >Не соответствует критериям финансовой устойчивости</span
                >
              </td>
            </tr>
            <tr>
              <td colspan="5" style="padding: 2px 0;font-size: 12px">
                <p>
                  *Анализ динамики показателей осуществляется путем
                  сопоставления значений показателей по итогам завершенного
                  финансового года с предыдущим финансовым годом.
                </p>
                <p>
                  **Требование не распространяется на организации, включенные в
                  Сводный реестр организаций оборонно-промышленного комплекса (в
                  том числе на дочерние общества таких организаций).
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="h3-tab-title">
          Виды основного обеспечения, принимаемого Фондом по финансируемым
          проектам
        </div>
        <table
          class="c-indicator table-lh-style content-mb-35"
          style="width: 100%"
        >
          <thead>
            <th class="tab-wid-630">Вид обеспечения</th>
            <th class="tab-wid-250">
              Юридическое или физическое лицо, предоставляющее обеспечение
            </th>
            <th class="tab-wid-97">
              Объем обеспечения, тыс. руб.<br /><span
                style="font-weight: normal;"
                >(рыночная стоимость без учета НДС)</span
              >
            </th>
            <th class="th-tc">Минимальный дисконт</th>
            <th class="tab-wid-85-np">
              Объем обеспечения с учетом дисконта, тыс. руб.
            </th>
            <th class="tab-wid-85">Наименование имущества</th>
            <th></th>
          </thead>
          <tbody>
            <tr class="screenplay-container-area">
              <td colspan="2"></td>
              <td
                colspan="3"
                class="screenplay-container"
                :class="[project.SUM_ZAIMA_HELP ? 'active' : '']"
                ref="SUM_ZAIMA_HELP"
              >
                <div style="float: right;">
                  <b>Общая сумма займа, тыс. руб.</b> (с учетом процентов)
                </div>
                <ThirdScenariosStep
                  :project="project"
                  step="SUM_ZAIMA_HELP"
                  step-name="SUM_ZAIMA_HELP"
                  custom-class="stl-lb-box"
                />
              </td>
              <td
                class="screenplay-container"
                :class="[project.SUM_ZAIMA_HELP ? 'active' : '']"
                ref="SUM_ZAIMA_HELP"
              >
                <input
                  type="text"
                  v-model="project.UF_ALL_SUMM_PROCENT"
                  class="i-main-style tab-wid-76"
                  disabled
                />
                <div class="screenplay-shadow"></div>
              </td>
              <td></td>
            </tr>
            <tr class="screenplay-container-area">
              <td colspan="2"></td>
              <td
                colspan="3"
                class="screenplay-container"
                :class="[project.UF_OLD_KRVARTAL_HELP ? 'active' : '']"
                ref="UF_OLD_KRVARTAL_HELP"
              >
                <div style="float: right;">
                  <b>Погашение осн. суммы долга, последних кварталов (кв.)</b>
                </div>
                <ThirdScenariosStep
                  :project="project"
                  step="UF_OLD_KRVARTAL_HELP"
                  step-name="UF_OLD_KRVARTAL_HELP"
                  custom-class="stl-lb-box"
                />
              </td>
              <td
                class="screenplay-container"
                :class="[project.UF_OLD_KRVARTAL_HELP ? 'active' : '']"
                ref="UF_OLD_KRVARTAL_HELP"
              >
                <input
                  type="text"
                  class="i-main-style tab-wid-76"
                  v-model="project.UF_OLD_KRVARTAL"
                  v-on:change="$parent.updateAllSumPercent()"
                  :disabled="$parent.projectDisabled || true"
                />
                <div class="screenplay-shadow"></div>
              </td>
              <td></td>
            </tr>

            <template v-for="(dir, index) in getProcurings()">
              <!--    таблица MAIN_COVER_HELP    -->
              <tr
                v-for="(item, ind) in getProcuringItems(dir.ID)"
                v-if="
                  dir.CODE !== 'poruchitelstvo' &&
                    dir.CODE !==
                      'poruchitelstvo_international_financial_organizations' &&
                    dir.CODE !== 'poruchitelstva-control-org'
                "
                :key="item.ID + '.' + item.UF_MAIN_COVER_ID + '.' + ind"
                class="screenplay-container-area"
              >
                <td
                  class="screenplay-container"
                  :class="[
                    project[`MAIN_COVER_HELP_${dir.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[dir.ID] ===
                      0
                      ? 'active'
                      : ''
                  ]"
                  :ref="`MAIN_COVER_HELP_${dir.ID}`"
                >
                  <span>
                    <b v-if="ind === 0">{{ index + 1 }}. {{ dir.NAME }}</b>
                    <VDropdown
                      v-if="dir.HELP"
                      tag="span"
                      trigger="click"
                      placement="bottom"
                      popperClass="custom-popper"
                      :distance="25"
                      style="display: inline"
                    >
                      <a class="icon-help-blue" />
                      <template #popper>
                        <div
                          class="custom-popper-content"
                          v-html="dir.HELP"
                        ></div>
                      </template>
                    </VDropdown>
                  </span>
                  <ThirdScenariosStep
                    :project="project"
                    step="MAIN_COVER_HELP"
                    :number-id="dir.ID"
                    :step-name="`MAIN_COVER_HELP_${dir.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container"
                  :class="{
                    'has-error': hasMainCoverError(
                      item.UF_MAIN_COVER_ID,
                      'UF_JUR_FACE'
                    ),
                    active:
                      project[`MAIN_COVER_HELP_${dir.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        dir.ID
                      ] === 1
                  }"
                  :ref="`MAIN_COVER_HELP_${dir.ID}`"
                >
                  <input
                    type="text"
                    class="i-main-style"
                    v-model="item.UF_JUR_FACE"
                    v-on:change="removeMainCoverError(item.UF_MAIN_COVER_ID)"
                    :disabled="
                      (dir.UF_IS_ALL_ZAIM_PR_BLOCK === 1 &&
                        project.UF_IS_ALL_ZAIM_PR == 1) ||
                        $parent.projectDisabled ||
                        blockByCFSError(dir.CODE)
                    "
                    v-if="dir.NO_JUR_NAME_ENTER !== 1"
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="MAIN_COVER_HELP"
                    :number-id="dir.ID"
                    :step-name="`MAIN_COVER_HELP_${dir.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container"
                  :class="{
                    'has-error': hasMainCoverError(
                      item.UF_MAIN_COVER_ID,
                      'UF_OBJEM_VALUE'
                    ),
                    active:
                      project[`MAIN_COVER_HELP_${dir.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        dir.ID
                      ] === 2
                  }"
                  :ref="`MAIN_COVER_HELP_${dir.ID}`"
                >
                  <input
                    type="text"
                    class="i-main-style"
                    v-on:keypress="isNumber($event)"
                    v-on:keyup="calcMainCoverDiscont(dir.ID, ind, dir.DISCONT)"
                    v-model="item.UF_OBJEM_VALUE"
                    v-on:change="removeMainCoverError(item.UF_MAIN_COVER_ID)"
                    :disabled="
                      (dir.UF_IS_ALL_ZAIM_PR_BLOCK === 1 &&
                        project.UF_IS_ALL_ZAIM_PR == 1) ||
                        $parent.projectDisabled ||
                        blockByCFSError(dir.CODE)
                    "
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="MAIN_COVER_HELP"
                    :number-id="dir.ID"
                    :step-name="`MAIN_COVER_HELP_${dir.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container cnt"
                  :class="[
                    project[`MAIN_COVER_HELP_${dir.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[dir.ID] ===
                      3
                      ? 'active'
                      : ''
                  ]"
                  :ref="`MAIN_COVER_HELP_${dir.ID}`"
                >
                  <span v-text="dir.DISCONT" />
                  <ThirdScenariosStep
                    :project="project"
                    step="MAIN_COVER_HELP"
                    :number-id="dir.ID"
                    :step-name="`MAIN_COVER_HELP_${dir.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container"
                  :class="[
                    project[`MAIN_COVER_HELP_${dir.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[dir.ID] ===
                      4
                      ? 'active'
                      : ''
                  ]"
                  :ref="`MAIN_COVER_HELP_${dir.ID}`"
                >
                  <input
                    type="text"
                    class="i-main-style"
                    v-model="item.UF_OBJEM_DISCONT_VAL"
                    :disabled="true"
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="MAIN_COVER_HELP"
                    :number-id="dir.ID"
                    :step-name="`MAIN_COVER_HELP_${dir.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container"
                  :class="[
                    project[`MAIN_COVER_HELP_${dir.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[dir.ID] ===
                      5
                      ? 'active'
                      : ''
                  ]"
                  :ref="`MAIN_COVER_HELP_${dir.ID}`"
                >
                  <input
                    v-if="dir.IS_VIEW_HAVINGS"
                    type="text"
                    class="i-main-style"
                    v-model="item.UF_HAVINGS"
                    :disabled="
                      (dir.UF_IS_ALL_ZAIM_PR_BLOCK === 1 &&
                        project.UF_IS_ALL_ZAIM_PR == 1) ||
                        $parent.projectDisabled ||
                        blockByCFSError(dir.CODE)
                    "
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="MAIN_COVER_HELP"
                    :number-id="dir.ID"
                    :step-name="`MAIN_COVER_HELP_${dir.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td>
                  <a
                    v-show="ind > 0 && !blockByCFSError(dir.CODE)"
                    v-on:click="deleteProcuring(dir.ID, ind)"
                    class="link-delete-row"
                  ></a>
                </td>
              </tr>

              <tr
                v-if="
                  dir.CODE === 'poruchitelstvo' ||
                    dir.CODE ===
                      'poruchitelstvo_international_financial_organizations' ||
                    dir.CODE === 'poruchitelstva-control-org'
                "
              >
                <td>
                  <b>{{ index + 1 }}. {{ dir.NAME }}</b>
                  <VDropdown
                    v-if="dir.HELP"
                    tag="span"
                    trigger="click"
                    placement="bottom"
                    popperClass="custom-popper"
                    :distance="25"
                    style="display: inline"
                  >
                    <a class="icon-help-blue" />
                    <template #popper>
                      <div
                        class="custom-popper-content"
                        v-html="dir.HELP"
                      ></div>
                    </template>
                  </VDropdown>
                  <i v-if="dir.DOP_TEXT"><br />{{ dir.DOP_TEXT }}</i>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              <tr
                v-for="(item, ind) in getProcuringItems(dir.ID)"
                v-bind:key="item.ID + '.' + item.UF_MAIN_COVER_ID + '.' + ind"
                v-if="
                  (dir.CODE === 'poruchitelstvo' ||
                    dir.CODE ===
                      'poruchitelstvo_international_financial_organizations' ||
                    dir.CODE === 'poruchitelstva-control-org') &&
                    item.UF_JUR_FACE != ''
                "
                class="ogrn"
              >
                <td
                  style="text-align: right"
                  v-if="
                    dir.CODE !==
                      'poruchitelstvo_international_financial_organizations'
                  "
                >
                  ОГРН
                  <input
                    type="text"
                    class="i-main-style"
                    style="width: 200px"
                    v-model="item.UF_OGRN"
                    v-on:change="removeMainCoverError(item.UF_MAIN_COVER_ID)"
                    disabled
                    v-if="dir.NO_JUR_NAME_ENTER !== 1"
                  />
                </td>
                <td v-else></td>
                <td
                  v-bind:class="{
                    'has-error': hasMainCoverError(
                      item.UF_MAIN_COVER_ID,
                      'UF_JUR_FACE'
                    )
                  }"
                >
                  <input
                    type="text"
                    class="i-main-style"
                    v-model="item.UF_JUR_FACE"
                    v-on:change="removeMainCoverError(item.UF_MAIN_COVER_ID)"
                    disabled
                    v-if="dir.NO_JUR_NAME_ENTER !== 1"
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasMainCoverError(
                      item.UF_MAIN_COVER_ID,
                      'UF_OBJEM_VALUE'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    type="text"
                    class="i-main-style"
                    v-on:keypress="isNumber($event)"
                    :keyup="calcMainCoverDiscont(dir.ID, ind, dir.DISCONT)"
                    v-model="item.UF_OBJEM_VALUE"
                    v-on:change="removeMainCoverError(item.UF_MAIN_COVER_ID)"
                    :disabled="
                      (dir.UF_IS_ALL_ZAIM_PR_BLOCK === 1 &&
                        project.UF_IS_ALL_ZAIM_PR == 1) ||
                        $parent.projectDisabled
                    "
                  />
                </td>
                <td style="text-align: center" v-text="dir.DISCONT"></td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    type="text"
                    class="i-main-style"
                    v-model="item.UF_OBJEM_DISCONT_VAL"
                    :disabled="true"
                  />
                </td>
                <td></td>
                <td>
                  <a
                    v-on:click="deleteProcuring(dir.ID, ind)"
                    class="link-delete-row"
                  ></a>
                </td>
              </tr>

              <tr
                v-if="dir.IS_MULTIPLY === 1 /*&& !blockByCFSError(dir.CODE)*/"
              >
                <td>
                  <template
                    v-if="
                      dir.CODE === 'poruchitelstvo' ||
                        dir.CODE === 'poruchitelstva-control-org'
                    "
                  >
                    <b>
                      <a v-on:click="findOrg(dir.ID)" class="add-t-r"></a>
                      Добавить "{{ dir.NAME }}"</b
                    >
                  </template>
                  <template
                    v-else-if="
                      dir.CODE ===
                        'poruchitelstvo_international_financial_organizations' &&
                        (project.MAIN_COVER.items[dir.ID] === undefined ||
                          project.MAIN_COVER.items[dir.ID].length == 0)
                    "
                  >
                    <b>
                      <a
                        v-on:click="addProcItem(dir.ID, dir)"
                        class="add-t-r"
                      ></a>
                      Добавить "{{ dir.NAME }}"</b
                    >
                  </template>

                  <template
                    v-else-if="
                      dir.CODE !== 'poruchitelstvo' &&
                        dir.CODE !==
                          'poruchitelstvo_international_financial_organizations'
                    "
                  >
                    <b>
                      <a class="add-t-r" v-on:click="addProcItem(dir.ID, dir)">
                      </a>
                      Добавить "{{ dir.NAME }}"</b
                    >
                  </template>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <!--    конец MAIN_COVER_HELP    -->
            </template>
            <tr>
              <td colspan="7"><b>11. Залоги</b></td>
            </tr>
            <template v-for="child in getZalogi()">
              <tr v-if="child.CODE == 'transport'">
                <td
                  v-bind:class="{ 'pd-col-37': child.IS_MULTI }"
                  colspan="7"
                  style="color:red;"
                >
                  Внимание! Оборудование, которое планируется передавать в залог
                  после его постановки на баланс (счет 01 "Основные средства"),
                  отражается в пункте 4 раздела "Виды дополнительного
                  обеспечения, принимаемого Фондом по финансируемым проектам"
                </td>
              </tr>
              <tr v-if="child.IS_ZG">
                <td>
                  <b>{{ child.INDEX }} {{ child.NAME }}</b>
                  <VDropdown
                    tag="span"
                    trigger="click"
                    placement="bottom"
                    popperClass="custom-popper"
                    :distance="25"
                    style="display: inline"
                  >
                    <a class="icon-help-blue" />
                    <template #popper>
                      <div
                        class="custom-popper-content"
                        v-html="child.HELP"
                      ></div>
                    </template>
                  </VDropdown>
                </td>
                <td></td>
                <td>
                  <input
                    type="text"
                    class="i-main-style"
                    :value="calcFirstSumZalogi()"
                    disabled
                  />
                </td>
                <td></td>
                <td>
                  <input
                    type="text"
                    class="i-main-style tab-wid-76"
                    :value="calcFirstSumZalogiDiscount()"
                    disabled
                  />
                </td>
                <td></td>
                <td></td>
              </tr>
              <!--    таблица ZALOGI_HELP    -->
              <tr
                v-if="!child.IS_ZG"
                v-for="(item, index) in project.ZALOG.items[child.ID]"
                :key="
                  item.ID > 0 ? item.ID + '.' + index : child.ID + '.' + index
                "
                class="screenplay-container-area"
              >
                <!--fixme конфликт стилей -->
                <!--:class="[child.IS_MULTI ? 'pd-col-37' : '']"-->
                <td
                  class="screenplay-container"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 0
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <div>
                    <div v-if="index === 0">
                      <b>{{ child.INDEX }} {{ child.NAME }}</b
                      >&nbsp;<span v-html="child.ADD_FULL_NAME"></span>
                      <VDropdown
                        v-if="child.HELP"
                        tag="span"
                        trigger="click"
                        placement="bottom"
                        popperClass="custom-popper"
                        :distance="25"
                        style="display: inline"
                      >
                        <a class="icon-help-blue" />
                        <template #popper>
                          <div
                            class="custom-popper-content"
                            v-html="child.HELP"
                          ></div>
                        </template>
                      </VDropdown>
                    </div>
                    <br />
                    <div v-if="child.IS_SET_VID_BONDS == 1">
                      <p v-for="obl in directory.sp_vid_oblegacii">
                        <label>
                          <input
                            type="radio"
                            v-model="item.UF_VID_BONDS_ID"
                            :value="obl.ID"
                            v-on:click="
                              calcMainZalogDiscont(
                                child.ID,
                                index,
                                getZalogDiscont(obl.ID)
                              )
                            "
                            :disabled="
                              $parent.projectDisabled ||
                                project.UF_IS_ALL_ZAIM_PR == 1
                            "
                            style="float:left; width: 20px;"
                          />
                          <span>{{ obl.NAME }}</span>
                        </label>
                      </p>
                    </div>
                    <div v-if="child.IS_SET_VID_TR == 1">
                      <p v-for="obl in directory.vid_transport">
                        <label>
                          <input
                            type="radio"
                            v-model="item.UF_VID_TR_ID"
                            :value="obl.ID"
                            style="float:left; width: 20px;"
                            :disabled="
                              $parent.projectDisabled ||
                                project.UF_IS_ALL_ZAIM_PR == 1
                            "
                          />
                          <span>{{ obl.NAME }}</span>
                        </label>
                      </p>
                    </div>
                  </div>
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 1
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <div v-if="child.IS_SET_TYPE_FACE_ZL == 1">
                    <p>Залогодателем выступает:</p>
                    <p>
                      <label v-for="faceItem in directory.type_face_zalog">
                        <input
                          type="radio"
                          v-model="item.UF_TYPE_FACE_ZL_ID"
                          :value="faceItem.ID"
                          style="float:left; width: 20px;"
                          :disabled="
                            $parent.projectDisabled ||
                              project.UF_IS_ALL_ZAIM_PR == 1
                          "
                        />
                        <span v-if="faceItem.IS_SET_NAME == 1">{{
                          faceItem.NAME
                        }}</span>
                        <span v-else>{{ project.ORG_INFO.UF_NAME }}</span>
                        <br />
                      </label>
                      <input
                        class="i-main-style"
                        v-if="showFaceZalogName(item.UF_TYPE_FACE_ZL_ID)"
                        type="text"
                        v-model="item.UF_NAME_FACE_ZALOG"
                        :disabled="
                          $parent.projectDisabled ||
                            project.UF_IS_ALL_ZAIM_PR == 1
                        "
                      />
                    </p>
                  </div>
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  v-if="child.IS_SET_VID_BONDS !== 1"
                  class="screenplay-container"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 2
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <input
                    v-model="item.UF_OBJEM_VALUE"
                    type="text"
                    class="i-main-style"
                    v-on:keyup="
                      calcMainZalogDiscont(child.ID, index, child.DISCONT)
                    "
                    :disabled="
                      $parent.projectDisabled || project.UF_IS_ALL_ZAIM_PR == 1
                    "
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  v-if="child.IS_SET_VID_BONDS === 1"
                  class="screenplay-container cnt"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 2
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <input
                    v-model="item.UF_OBJEM_VALUE"
                    type="text"
                    class="i-main-style"
                    v-on:keyup="
                      calcMainZalogDiscont(
                        child.ID,
                        index,
                        getZalogDiscont(item.UF_VID_BONDS_ID)
                      )
                    "
                    :disabled="
                      $parent.projectDisabled || project.UF_IS_ALL_ZAIM_PR == 1
                    "
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  v-if="child.IS_SET_VID_BONDS !== 1"
                  class="screenplay-container cnt"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 3
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <span v-text="child.DISCONT" />
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container cnt"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 3
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                  v-if="child.IS_SET_VID_BONDS === 1"
                >
                  <span style="text-align: center">{{
                    getZalogDiscont(item.UF_VID_BONDS_ID)
                  }}</span>
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container cnt"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 4
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <input
                    type="text"
                    :value="item.UF_OBJEM_DISCONT_VAL"
                    class="i-main-style tab-wid-76"
                    disabled
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container cnt"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 5
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <input
                    style="width: 250px"
                    type="text"
                    v-model="item.UF_HAVINGS"
                    class="i-main-style"
                    :disabled="
                      $parent.projectDisabled || project.UF_IS_ALL_ZAIM_PR == 1
                    "
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td>
                  <a
                    v-if="
                      item.UF_VID_TR_ID > 0 ||
                        item.UF_TYPE_FACE_ZL_ID > 0 ||
                        item.UF_VID_BONDS_ID > 0 ||
                        item.UF_JUR_FACE !== '' ||
                        item.UF_OBJEM_VALUE !== 0 ||
                        item.UF_NAME_FACE_ZALOG !== '' ||
                        item.UF_HAVINGS !== ''
                    "
                    v-on:click="clearRowZalog(item)"
                    class="link-clear-row"
                    title="Очистить данные в строке"
                  ></a>
                  <a
                    v-show="index > 0"
                    v-on:click="deleteZalog(child.ID, index)"
                    class="link-delete-row"
                  ></a>
                </td>
              </tr>
              <!--    конец ZALOGI_HELP    -->
              <tr v-show="!child.IS_ZG && project.UF_IS_ALL_ZAIM_PR != 1">
                <td v-bind:class="{ 'pd-col-37': child.IS_MULTI }">
                  <b v-on:click="addZalogItem(child.ID)"
                    ><a class="add-t-r"></a> Добавить</b
                  >
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </template>
            <tr class="tr-foot-itog">
              <td></td>
              <td class="pd-col-62">ИТОГО</td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcFirstSum()"
                />
              </td>
              <td></td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcFirstSumDiscount()"
                />
              </td>
              <td></td>
              <td></td>
            </tr>
            <template v-for="child in getZalogTransport()">
              <tr
                class="tr-foot-last screenplay-container-area hide"
                v-for="(item, index) in project.ZALOG.items[child.ID]"
                v-bind:key="
                  item.ID > 0 ? item.ID + '.' + index : child.ID + '.' + index
                "
              >
                <!--fixme конфликт стилей -->
                <!--:class="[child.IS_MULTI ? 'pd-col-37' : '']"-->
                <td
                  class="screenplay-container"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 0
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <div>
                    <div v-if="index === 0">
                      <strong>{{ child.INDEX }} {{ child.NAME }}</strong
                      >&nbsp;<span v-html="child.ADD_FULL_NAME"></span>
                      <VDropdown
                        v-if="child.HELP"
                        tag="span"
                        trigger="click"
                        placement="bottom"
                        popperClass="custom-popper"
                        :distance="25"
                        style="display: inline"
                      >
                        <a class="icon-help-blue" />
                        <template #popper>
                          <div
                            class="custom-popper-content"
                            v-html="child.HELP"
                          ></div>
                        </template>
                      </VDropdown>
                    </div>
                    <br />
                    <div v-if="child.IS_SET_VID_BONDS == 1">
                      <p v-for="obl in directory.sp_vid_oblegacii">
                        <label>
                          <input
                            type="radio"
                            v-model="item.UF_VID_BONDS_ID"
                            :value="obl.ID"
                            v-on:click="
                              calcMainZalogDiscont(
                                child.ID,
                                index,
                                getZalogDiscont(obl.ID)
                              )
                            "
                            :disabled="
                              $parent.projectDisabled ||
                                project.UF_IS_ALL_ZAIM_PR == 1
                            "
                            style="float:left; width: 20px;"
                          />
                          <span>{{ obl.NAME }}</span>
                        </label>
                      </p>
                    </div>
                    <div v-if="child.IS_SET_VID_TR == 1">
                      <p v-for="obl in directory.vid_transport">
                        <label>
                          <input
                            type="radio"
                            v-model="item.UF_VID_TR_ID"
                            :value="obl.ID"
                            style="float:left; width: 20px;"
                            :disabled="
                              $parent.projectDisabled ||
                                project.UF_IS_ALL_ZAIM_PR == 1
                            "
                          />
                          <span>{{ obl.NAME }}</span>
                        </label>
                      </p>
                    </div>
                  </div>
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container"
                  :class="{
                    'has-error': hasZalogError(index, 'UF_TYPE_FACE_ZL_ID'),
                    active:
                      project[`ZALOGI_HELP_${child.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        child.ID
                      ] === 1
                  }"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <div v-if="child.IS_SET_TYPE_FACE_ZL == 1">
                    <p>Залогодателем выступает:</p>
                    <p>
                      <label v-for="faceItem in directory.type_face_zalog">
                        <input
                          type="radio"
                          v-model="item.UF_TYPE_FACE_ZL_ID"
                          :value="faceItem.ID"
                          style="float:left; width: 20px;"
                          @click="removeZalogError(index)"
                          :disabled="
                            $parent.projectDisabled ||
                              project.UF_IS_ALL_ZAIM_PR == 1
                          "
                        />
                        <span v-if="faceItem.IS_SET_NAME == 1">{{
                          faceItem.NAME
                        }}</span>
                        <span v-else>{{ project.ORG_INFO.UF_NAME }}</span>
                        <br />
                      </label>
                      <input
                        class="i-main-style"
                        v-if="showFaceZalogName(item.UF_TYPE_FACE_ZL_ID)"
                        type="text"
                        v-model="item.UF_NAME_FACE_ZALOG"
                      />
                    </p>
                  </div>
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  v-if="child.IS_SET_VID_BONDS !== 1"
                  class="screenplay-container"
                  :class="{
                    'has-error': hasZalogError(index, 'UF_OBJEM_VALUE'),
                    active:
                      project[`ZALOGI_HELP_${child.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        child.ID
                      ] === 2
                  }"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <input
                    v-model="item.UF_OBJEM_VALUE"
                    type="text"
                    class="i-main-style"
                    v-on:keyup="
                      calcMainZalogDiscont(child.ID, index, child.DISCONT)
                    "
                    :disabled="
                      $parent.projectDisabled || project.UF_IS_ALL_ZAIM_PR == 1
                    "
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  v-if="child.IS_SET_VID_BONDS === 1"
                  class="screenplay-container"
                  :class="{
                    'has-error': hasZalogError(index, 'UF_OBJEM_VALUE'),
                    active:
                      project[`ZALOGI_HELP_${child.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        child.ID
                      ] === 2
                  }"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <input
                    v-model="item.UF_OBJEM_VALUE"
                    type="text"
                    class="i-main-style"
                    v-on:keyup="
                      calcMainZalogDiscont(
                        child.ID,
                        index,
                        getZalogDiscont(item.UF_VID_BONDS_ID)
                      )
                    "
                    :disabled="
                      $parent.projectDisabled || project.UF_IS_ALL_ZAIM_PR == 1
                    "
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  v-if="child.IS_SET_VID_BONDS !== 1"
                  class="screenplay-container cnt"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 3
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <span v-text="child.DISCONT" />
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  v-if="child.IS_SET_VID_BONDS === 1"
                  class="screenplay-container"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 3
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <span style="text-align: center">{{
                    getZalogDiscont(item.UF_VID_BONDS_ID)
                  }}</span>
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container"
                  :class="{
                    'has-error': hasZalogError(index, 'UF_OBJEM_DISCONT_VAL'),
                    active:
                      project[`ZALOGI_HELP_${child.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        child.ID
                      ] === 4
                  }"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <input
                    type="text"
                    :value="item.UF_OBJEM_DISCONT_VAL"
                    class="i-main-style tab-wid-76"
                    disabled
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="tab-wid-250 screenplay-container"
                  :class="{
                    'has-error': hasZalogError(index, 'UF_HAVINGS'),
                    active:
                      project[`ZALOGI_HELP_${child.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        child.ID
                      ] === 4
                  }"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <input
                    type="text"
                    v-model="item.UF_HAVINGS"
                    @keyup="removeZalogError(index)"
                    class="i-main-style"
                    :disabled="
                      $parent.projectDisabled || project.UF_IS_ALL_ZAIM_PR == 1
                    "
                  />
                  <ThirdScenariosStep
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <a
                  v-if="
                    item.UF_VID_TR_ID > 0 ||
                      item.UF_TYPE_FACE_ZL_ID > 0 ||
                      item.UF_VID_BONDS_ID > 0 ||
                      item.UF_JUR_FACE !== '' ||
                      item.UF_OBJEM_VALUE !== 0 ||
                      item.UF_NAME_FACE_ZALOG !== '' ||
                      item.UF_HAVINGS !== ''
                  "
                  v-on:click="clearRowZalog(item)"
                  class="link-clear-row"
                  title="Очистить данные в строке"
                ></a>
                <a
                  v-show="index > 0"
                  v-on:click="deleteZalog(child.ID, index)"
                  class="link-delete-row"
                  title="Удалить строку"
                ></a>
              </tr>
              <tr v-show="project.UF_IS_ALL_ZAIM_PR != 1" class="hide">
                <td v-bind:class="{ 'pd-col-37': child.IS_MULTI }">
                  <b v-on:click="addZalogItem(child.ID)"
                    ><a class="add-t-r"></a> Добавить</b
                  >
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </template>
            <tr class="tr-foot-itog hide">
              <td></td>
              <td class="pd-col-62">ИТОГО</td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcFirstSum() + calcFirstSumTransport()"
                  :disabled="$parent.projectDisabled"
                />
              </td>
              <td></td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="
                    calcFirstSumDiscount() + calcFirstSumDiscountTransport()
                  "
                  :disabled="$parent.projectDisabled"
                />
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div class="h3-tab-title">
          <div style="display: inline-block; padding-top: 4px;">
            Виды дополнительного обеспечения, принимаемого Фондом по
            финансируемым проектам
          </div>
          <VDropdown
            tag="span"
            trigger="click"
            placement="bottom"
            popperClass="custom-popper"
            :distance="25"
            style="display: inline"
          >
            <a class="icon-help" />
            <template #popper>
              <div class="custom-popper-content" v-html="h2tooltip"></div>
            </template>
          </VDropdown>
        </div>
        <table
          class="c-indicator table-lh-style content-mb-35"
          style="width: 100%"
        >
          <thead>
            <th class="tab-wid-630">Вид обеспечения</th>
            <th class="tab-wid-250">
              Юридическое или физическое лицо, предоставляющее обеспечение
            </th>
            <th class="tab-wid-97">
              Объем обеспечения, тыс. руб.<br /><span
                style="font-weight: normal;"
                >(балансовая/рыночная стоимость без учета НДС)</span
              >
            </th>
            <th class="th-tc">Минимальный дисконт</th>
            <th class="tab-wid-85-np">
              Объем обеспечения с учетом дисконта, тыс. руб.
            </th>
            <th class="tab-wid-85">Наименование имущества</th>
            <th></th>
          </thead>
          <tbody>
            <template v-for="(pr, index) in directory.dop_procuring">
              <tr v-for="(item, ind) in project.DOP_COVER.items[pr.ID]">
                <td>
                  <b v-if="ind === 0">{{ index + 1 }}. {{ pr.NAME }}</b>
                </td>
                <td>
                  <input
                    type="text"
                    class="i-main-style"
                    v-model="item.UF_JUR_FACE"
                    :disabled="$parent.projectDisabled"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="i-main-style"
                    v-model="item.UF_OBJEM_VALUE"
                    v-on:keyup="calcDopCoverDiscont(pr.ID, ind, 0)"
                    :disabled="$parent.projectDisabled"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="t-result-style tc-main"
                    v-model="pr.DISCONT"
                    :disabled="$parent.projectDisabled"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="i-main-style tab-wid-76"
                    disabled
                    v-model="item.UF_OBJEM_DISCONT_VAL"
                  />
                </td>
                <td class="tab-wid-250">
                  <input
                    type="text"
                    class="i-main-style"
                    v-model="item.UF_HAVINGS"
                    :disabled="$parent.projectDisabled"
                  />
                </td>
                <td>
                  <a
                    v-if="
                      item.UF_JUR_FACE !== '' ||
                        item.UF_OBJEM_VALUE > 0 ||
                        item.UF_HAVINGS !== ''
                    "
                    v-on:click="clearRowDopZalog(item)"
                    class="link-clear-row"
                    title="Очистить данные в строке"
                  ></a>

                  <a
                    v-show="ind > 0"
                    v-on:click="deleteDopZalog(pr.ID, ind)"
                    class="link-delete-row"
                    title="Удалить строку"
                  ></a>
                </td>
              </tr>
              <tr>
                <td>
                  <b v-on:click="addDopProcItem(pr.ID)"
                    ><a class="add-t-r"></a> Добавить</b
                  >
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </template>

            <!-- транспортные средства дополнительное обеспечение -->
            <template v-for="child in getZalogTransport()">
              <tr
                class="tr-foot-last screenplay-container-area"
                v-for="(item, index) in project.ZALOG.items[child.ID]"
                :key="
                  item.ID > 0 ? item.ID + '.' + index : child.ID + '.' + index
                "
              >
                <!--fixme конфликт стилей -->
                <!--:class="[child.IS_MULTI ? 'pd-col-37' : '']"-->
                <td
                  class="screenplay-container"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 0 &&
                    index === 0
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <div>
                    <div v-if="index === 0">
                      <strong>4. {{ child.NAME }}</strong
                      >&nbsp;<span v-html="child.ADD_FULL_NAME"></span>
                      <VDropdown
                        v-if="child.HELP"
                        tag="span"
                        trigger="click"
                        placement="bottom"
                        popperClass="custom-popper"
                        :distance="25"
                        style="display: inline"
                      >
                        <a class="icon-help-blue" />
                        <template #popper>
                          <div
                            class="custom-popper-content"
                            v-html="child.HELP"
                          ></div>
                        </template>
                      </VDropdown>
                    </div>
                    <br />
                    <div v-if="child.IS_SET_VID_BONDS == 1">
                      <p v-for="obl in directory.sp_vid_oblegacii">
                        <label>
                          <input
                            type="radio"
                            v-model="item.UF_VID_BONDS_ID"
                            :value="obl.ID"
                            v-on:click="
                              calcMainZalogDiscont(
                                child.ID,
                                index,
                                getZalogDiscont(obl.ID)
                              )
                            "
                            :disabled="$parent.projectDisabled"
                            style="float:left; width: 20px;"
                          />
                          <span>{{ obl.NAME }}</span>
                        </label>
                      </p>
                    </div>
                    <div v-if="child.IS_SET_VID_TR == 1">
                      <p v-for="obl in directory.vid_transport">
                        <label>
                          <input
                            type="radio"
                            v-model="item.UF_VID_TR_ID"
                            :value="obl.ID"
                            style="float:left; width: 20px;"
                            :disabled="$parent.projectDisabled"
                          />
                          <span>{{ obl.NAME }}</span>
                        </label>
                      </p>
                    </div>
                  </div>
                  <ThirdScenariosStep
                    v-if="index === 0"
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container"
                  :class="{
                    'has-error': hasZalogError(index, 'UF_TYPE_FACE_ZL_ID'),
                    active:
                      project[`ZALOGI_HELP_${child.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        child.ID
                      ] === 1 &&
                      index === 0
                  }"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <div v-if="child.IS_SET_TYPE_FACE_ZL == 1">
                    <p>Залогодателем выступает:</p>
                    <p>
                      <label v-for="faceItem in directory.type_face_zalog">
                        <input
                          type="radio"
                          v-model="item.UF_TYPE_FACE_ZL_ID"
                          :value="faceItem.ID"
                          style="float:left; width: 20px;"
                          @click="removeZalogError(index)"
                          :disabled="$parent.projectDisabled"
                        />
                        <span v-if="faceItem.IS_SET_NAME == 1">{{
                          faceItem.NAME
                        }}</span>
                        <span v-else>{{ project.ORG_INFO.UF_NAME }}</span>
                        <br />
                      </label>
                      <input
                        class="i-main-style"
                        v-if="showFaceZalogName(item.UF_TYPE_FACE_ZL_ID)"
                        type="text"
                        v-model="item.UF_NAME_FACE_ZALOG"
                      />
                    </p>
                  </div>
                  <ThirdScenariosStep
                    v-if="index === 0"
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  v-if="child.IS_SET_VID_BONDS !== 1"
                  class="screenplay-container"
                  :class="{
                    'has-error': hasZalogError(index, 'UF_OBJEM_VALUE'),
                    active:
                      project[`ZALOGI_HELP_${child.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        child.ID
                      ] === 2 &&
                      index === 0
                  }"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="item.UF_OBJEM_VALUE"
                    type="text"
                    class="i-main-style"
                    :keyup="
                      calcMainZalogDiscont(child.ID, index, child.DISCONT)
                    "
                    :disabled="$parent.projectDisabled"
                  />
                  <ThirdScenariosStep
                    v-if="index === 0"
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  v-if="child.IS_SET_VID_BONDS === 1"
                  class="screenplay-container"
                  :class="{
                    'has-error': hasZalogError(index, 'UF_OBJEM_VALUE'),
                    active:
                      project[`ZALOGI_HELP_${child.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        child.ID
                      ] === 2 &&
                      index === 0
                  }"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="item.UF_OBJEM_VALUE"
                    type="text"
                    class="i-main-style"
                    :keyup="
                      calcMainZalogDiscont(
                        child.ID,
                        index,
                        getZalogDiscont(item.UF_VID_BONDS_ID)
                      )
                    "
                    :disabled="$parent.projectDisabled"
                  />
                  <ThirdScenariosStep
                    v-if="index === 0"
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  v-if="child.IS_SET_VID_BONDS !== 1"
                  class="screenplay-container cnt"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 3 &&
                    index === 0
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <span v-text="child.DISCONT" />
                  <ThirdScenariosStep
                    v-if="index === 0"
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  v-if="child.IS_SET_VID_BONDS === 1"
                  class="screenplay-container"
                  :class="[
                    project[`ZALOGI_HELP_${child.ID}`] &&
                    project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                      child.ID
                    ] === 3 &&
                    index === 0
                      ? 'active'
                      : ''
                  ]"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <span style="text-align: center">{{
                    getZalogDiscont(item.UF_VID_BONDS_ID)
                  }}</span>
                  <ThirdScenariosStep
                    v-if="index === 0"
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="screenplay-container"
                  :class="{
                    'has-error': hasZalogError(index, 'UF_OBJEM_DISCONT_VAL'),
                    active:
                      project[`ZALOGI_HELP_${child.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        child.ID
                      ] === 4 &&
                      index === 0
                  }"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    type="text"
                    :value="item.UF_OBJEM_DISCONT_VAL"
                    class="i-main-style tab-wid-76"
                    disabled
                  />
                  <ThirdScenariosStep
                    v-if="index === 0"
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td
                  class="tab-wid-250 screenplay-container"
                  :class="{
                    'has-error': hasZalogError(index, 'UF_HAVINGS'),
                    active:
                      project[`ZALOGI_HELP_${child.ID}`] &&
                      project.UF_HELP.SCENARIO.STEP3_TYPE_AREA_SELECT[
                        child.ID
                      ] === 4 &&
                      index === 0
                  }"
                  :ref="`ZALOGI_HELP_${child.ID}`"
                >
                  <input
                    type="text"
                    v-model="item.UF_HAVINGS"
                    @keyup="removeZalogError(index)"
                    class="i-main-style"
                    :disabled="$parent.projectDisabled"
                  />
                  <ThirdScenariosStep
                    v-if="index === 0"
                    :project="project"
                    step="ZALOGI_HELP"
                    :number-id="child.ID"
                    :step-name="`ZALOGI_HELP_${child.ID}`"
                    custom-class="stl-lb-box"
                  />
                </td>
                <td>
                  <a
                    v-if="
                      item.UF_VID_TR_ID > 0 ||
                        item.UF_TYPE_FACE_ZL_ID > 0 ||
                        item.UF_VID_BONDS_ID > 0 ||
                        item.UF_JUR_FACE !== '' ||
                        item.UF_OBJEM_VALUE !== 0 ||
                        item.UF_NAME_FACE_ZALOG !== '' ||
                        item.UF_HAVINGS !== ''
                    "
                    v-on:click="clearRowZalog(item)"
                    class="link-clear-row"
                    title="Очистить данные в строке"
                  ></a>
                  <a
                    v-show="index > 0"
                    v-on:click="deleteZalog(child.ID, index)"
                    class="link-delete-row"
                    title="Удалить строку"
                  ></a>
                </td>
              </tr>
              <tr v-show="!$parent.projectDisabled">
                <td v-bind:class="{ 'pd-col-37': child.IS_MULTI }">
                  <b v-on:click="addZalogItem(child.ID)"
                    ><a class="add-t-r"></a> Добавить</b
                  >
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </template>
            <tr class="tr-foot-itog">
              <td></td>
              <td class="pd-col-62">ИТОГО</td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="
                    (calcDopSum() +
                      /*calcFirstSum() +*/ calcFirstSumTransport())
                      | toCurrency
                  "
                  :disabled="$parent.projectDisabled"
                />
              </td>
              <td></td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="
                    (calcDopSumDiscont() +
                      /*calcFirstSumDiscount() +*/ calcFirstSumDiscountTransport())
                      | toCurrency
                  "
                  :disabled="$parent.projectDisabled"
                />
              </td>
              <td></td>
              <td></td>
            </tr>
            <!-- транспортные средства дополнительное обеспечение -->

            <tr class="tr-foot-last hide">
              <td colspan="6"></td>
            </tr>
            <tr class="tr-foot-itog hide">
              <td class="pd-col-62">ИТОГО</td>
              <td></td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcDopSum()"
                  :disabled="$parent.projectDisabled"
                />
              </td>
              <td></td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcDopSumDiscont()"
                  :disabled="$parent.projectDisabled"
                />
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="modal fade in"
      v-bind:class="{ show: showOgrnFind }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showOgrnFind = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Добавление поручителя</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>ОГРН</label>
              <input v-model="ogrn" class="form-control" placeholder="ОГРН" />
            </div>
            <div class="form-group" v-if="isViewNameOrg">
              <label>Краткое наименование организации</label>
              <input
                v-model="nameOrg"
                class="form-control"
                placeholder="Краткое наименование организации"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="addSubContact"
              type="button"
              class="btn btn-primary"
            >
              Добавить организацию
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
  <!--container-fluid-->
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import { ProjectsService } from "@/common/api.service";
import ThirdScenariosStep from "@/components/project/form/subpartial/ThirdScenariosStep.vue";
import { Dropdown as VDropdown } from "floating-vue";

export default {
  name: "step4",
  components: { ThirdScenariosStep, VDropdown },
  props: ["step", "project"],
  data() {
    return {
      showOgrnFind: false,
      ogrn: "",
      pid: 0,
      loaded: false,
      h2tooltip:
        "  <b> Виды имущества, не принимаемого Фондом в качестве обеспечения:</b>\n" +
        "                                     <p>1. Имущество, залог которого ограничен или запрещен законом (ст. 336 Гражданского кодекса РФ):</p>\n" +
        '                                     <ul style="margin-left:24px;">\n' +
        "                                         <li>объекты гражданских прав, ограниченные в обороте (ст. 129 Гражданского кодекса РФ)</li>\n" +
        "                                         <li>имущество, которое не может свободно отчуждаться или переходить от одного лица к другому (п. 1 ст. 129 Гражданского кодекса РФ)</li>\n" +
        "                                         <li>виды объектов гражданских прав, нахождение в обороте которых не допускается, должны быть прямо указаны в законе (п. 2 ст. 129 Гражданского кодекса РФ)</li>\n" +
        "                                    </ul>\n" +
        "                                     <p>2. Имущество, свободная реализация которого запрещена в соответствии с законодательством РФ: вооружение, боеприпасы, военная техника, все виды ракетного топлива, ракетно-космические комплексы, системы связи и управления военного назначения и т.д.</p>\n" +
        "                                     <p>3. Земельные участки, перечисленные в ст. 27 Земельного кодекса РФ:</p>\n" +
        '                                     <ul style="margin-left:24px;">\n' +
        "                                        <li>ограничиваются в обороте находящиеся в государственной или муниципальной собственности следующие земельные участки: в пределах особо охраняемых природных территорий, из состава земель лесного фонда, в пределах которых расположены водные объекты, находящиеся в государственной или муниципальной собственности, занятые особо ценными объектами культурного наследия народов Российской Федерации, объектами, включенными в Список всемирного наследия, историко-культурными заповедниками, объектами археологического наследия, музеями-заповедниками, предоставленные для обеспечения обороны и безопасности, оборонной промышленности, таможенных нужд, занятые объектами космической инфраструктуры и т.д.)</li>\n" +
        "                                        <li>изъятые из оборота земельные участки, занятые находящимися в федеральной собственности следующими объектами: государственными природными заповедниками и национальными парками, зданиями, сооружениями, в которых размещены для постоянной деятельности Вооруженные Силы Российской Федерации, другие войска, воинские формирования и органы, зданиями, сооружениями, в которых размещены военные суды, объектами организаций федеральной службы безопасности, объектами организаций органов государственной охраны, объектами использования атомной энергии, пунктами хранения ядерных материалов и радиоактивных веществ, объектами, в соответствии с видами деятельности которых созданы закрытые административно-территориальные образования, объектами учреждений и органов Федеральной службы исполнения наказаний и т.д.</li>\n" +
        "                                     </ul>\n" +
        "                                     <p>4. Земельные участки, относящиеся к лесному фонду (ст. 8 Лесного кодекса РФ)</p>\n" +
        '                                     <p>5. Участки недр (ст. 1.2. Закона "О недрах")</p>\n' +
        '                                     <p>6. Часть земельного участка, площадь которого меньше минимального размера, установленного нормативными актами субъектов РФ и нормативными актами органов местного самоуправления для земель различного и разрешенного использования (ст. 63 Закона "06 ипотеке")</p>\n' +
        '                                     <p>7. Доли в праве собственности на земельный участок (ст. 62 Закона "06 ипотеке", кроме случая залога доли а праве собственности на земельный участок одновременно с залогом здания, сооружения, помещения (ст. 69 Закона "Об ипотеке")</p>\n' +
        "                                     <p>8. Недвижимое имущество граждан, на которое в соответствии с законодательством не может быть обращено взыскание (ст. 446 ГПК РФ). Другие объекты гражданских прав, на которые в соответствии с законом не может быть обращено взыскание, изъятые из оборота, свободная реализация которых запрещена</p>",
      isViewNameOrg: false,
      nameOrg: ""
    };
  },
  created() {},
  mounted() {
    this.$store
      .dispatch(FETCH_DIRECTORIES, [
        "procuring",
        "type_face_zalog",
        "sp_vid_oblegacii",
        "vid_transport",
        "program_fin_support"
      ])
      .then(() => {
        if (this.project.MAIN_COVER.items.length === 0) {
          this.project.MAIN_COVER.items = new Object();
        }
        this.project.MAIN_COVER.MAIN_COVER_ID.forEach(function(coverId) {
          if (typeof this.project.MAIN_COVER.items[coverId] === "undefined") {
            Vue.set(this.project.MAIN_COVER.items, coverId, [
              {
                UF_JUR_FACE: "",
                UF_MAIN_COVER_ID: coverId,
                UF_OBJEM_DISCONT_VAL: 0,
                UF_OBJEM_VALUE: 0,
                UF_PROJECT_ID: this.project.ID
              }
            ]);
          }
        }, this);
        this.clearDefaultMainCoverHavings();
      });

    this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_criteria_financial_stability"])
      .then(() => {
        this.directory.sp_criteria_financial_stability.forEach(function(
          source
        ) {
          let n = false;
          this.project.CRITERIA_FINANCIAL_STABILITY.items.forEach(function(
            item
          ) {
            if (source.ID === item.UF_CRT_FINANCIAL_ID) {
              n = true;
              if (source.IS_DEPENDENCE_ZAIM) {
                item.UF_DEPENDENCE_VAL = this.project.UF_SUM_REQUEST;
              }
            }
          },
          this);
          if (!n) {
            let dv = "";
            if (source.IS_DEPENDENCE_ZAIM) {
              dv = this.project.UF_SUM_REQUEST;
            }
            this.project.CRITERIA_FINANCIAL_STABILITY.items.push({
              UF_CRT_FINANCIAL_ID: source.ID,
              UF_PROJECT_ID: this.project.ID,
              UF_CRT_FINANCIAL_VAL: "",
              UF_DEPENDENCE_VAL: dv,
              UF_CRT_FINANCIAL_TTL: ""
            });
          }
        },
        this);
      }, this);
    this.$store.dispatch(FETCH_DIRECTORY, ["dop_procuring"]).then(() => {
      if (this.project.DOP_COVER.items.length === 0) {
        this.project.DOP_COVER.items = new Object();
      }
      this.directory.dop_procuring.forEach(function(item) {
        if (typeof this.project.DOP_COVER.items[item.ID] === "undefined") {
          Vue.set(this.project.DOP_COVER.items, item.ID, [
            {
              UF_DOP_COVER_ID: item.ID,
              UF_HAVINGS: "",
              UF_JUR_FACE: "",
              UF_OBJEM_DISCONT_VAL: 0,
              UF_OBJEM_VALUE: 0,
              UF_PROJECT_ID: this.project.ID
            }
          ]);
        }
      }, this);
    });
    this.$store.dispatch(FETCH_DIRECTORY, ["tree/zalogi"]).then(() => {
      if (this.project.ZALOG.items.length === 0) {
        this.project.ZALOG.items = new Object();
      }
      this.project.ZALOG.ZALOG_ID.forEach(function(zalogId) {
        if (typeof this.project.ZALOG.items[zalogId] === "undefined") {
          Vue.set(this.project.ZALOG.items, zalogId, [
            {
              UF_HAVINGS: "",
              UF_JUR_FACE: "",
              UF_NAME_FACE_ZALOG: "",
              UF_OBJEM_DISCONT_VAL: 0,
              UF_OBJEM_VALUE: 0,
              UF_PROJECT_ID: this.project.ID,
              UF_TYPE_FACE_ZL_ID: null,
              UF_VID_BONDS_ID: null,
              UF_VID_TR_ID: null,
              UF_ZALOG_ID: zalogId
            }
          ]);
        }
      }, this);

      this.directory.tree_zalogi.forEach(function(item) {
        item.CHILD.forEach(function(child) {
          if (child.CODE === "transport2") {
            if (typeof this.project.ZALOG.items[child.ID] === "undefined") {
              Vue.set(this.project.ZALOG.items, child.ID, [
                {
                  UF_HAVINGS: "",
                  UF_JUR_FACE: "",
                  UF_NAME_FACE_ZALOG: "",
                  UF_OBJEM_DISCONT_VAL: 0,
                  UF_OBJEM_VALUE: 0,
                  UF_PROJECT_ID: this.project.ID,
                  UF_TYPE_FACE_ZL_ID: null,
                  UF_VID_BONDS_ID: null,
                  UF_VID_TR_ID: null,
                  UF_ZALOG_ID: child.ID
                }
              ]);
            }
          }
        }, this);
      }, this);

      this.project.CRITERIA_FINANCIAL_STABILITY.items.forEach(function(item) {
        this.calcCFS(item);
      }, this);

      this.loaded = true;
    });
  },
  methods: {
    findOrg(id) {
      this.showResident = false;
      this.ogrn = "";
      this.pid = id;
      this.showOgrnFind = true;
    },
    addSubContact() {
      ProjectsService.getCoAuthorInfoByOgrn2(this.ogrn, {
        UF_NAME: this.nameOrg
      }).then(({ data }) => {
        if (!data.IS_FIND) {
          this.$toasted.show(data.ERROR, {
            theme: "red",
            position: "top-right",
            duration: 3000
          });
          this.isViewNameOrg = true;
          this.nameOrg = "";
          return;
        }
        this.showOgrnFind = false;
        this.isViewNameOrg = false;
        this.nameOrg = "";
        this.project.MAIN_COVER.items[this.pid].push({
          UF_OGRN: data.UF_OGRN,
          UF_JUR_FACE: data.UF_NAME,
          UF_COMPANY_ID: data.UF_COMPANY_ID,
          UF_MAIN_COVER_ID: this.pid,
          UF_OBJEM_DISCONT_VAL: 0,
          UF_OBJEM_VALUE: 0,
          UF_PROJECT_ID: this.project.ID
        });
      }, this);
    },
    stepNumber(num) {
      let steps = {
        18: 19
      };
      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "cifrovizaciya" ||
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
          "complectyushie" ||
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
          "complectyushie_rfrp" ||
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "evolution"
      ) {
        steps = {
          18: 20
        };
      }
      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
        "complectyushie_rfrp"
      ) {
        steps = {
          18: 19
        };
      }
      return steps[num] + (this.project.UF_SETTING && this.project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1 ? 1 : 0);
    },
    calcCFS(item) {
      if (item.UF_DEPENDENCE_VAL > 0 && item.UF_CRT_FINANCIAL_VAL > 0) {
        item.UF_CRT_FINANCIAL_TTL = parseFloat(
          item.UF_CRT_FINANCIAL_VAL / item.UF_DEPENDENCE_VAL
        ).toFixed(1);
      } else {
        item.UF_CRT_FINANCIAL_TTL = "";
      }
    },
    showCFSError(item, criteria) {
      if (
        item.UF_CRT_FINANCIAL_VAL == null ||
        item.UF_CRT_FINANCIAL_VAL === "" ||
        item.UF_DEPENDENCE_VAL == null ||
        item.UF_DEPENDENCE_VAL == null
      ) {
        return criteria.ERROR_TEXT;
      }
      let ttl = item.UF_CRT_FINANCIAL_TTL;
      if (criteria.CODE === "dolg_old_4_month" && ttl <= 0) {
        return "";
      }
      if (ttl <= 0) {
        return criteria.ERROR_TEXT;
      }

      if (criteria.CODE === "vurychka_old_year") {
        criteria.ERROR_CONDITION_VALUE = 5;
      }

      if (criteria.CODE === "dolg_old_4_month") {
        criteria.ERROR_CONDITION_VALUE = 6;
      }

      let ct = eval(
        ttl + criteria.ERROR_CONDITION_SIGN + criteria.ERROR_CONDITION_VALUE
      );
      if (ct) {
        return criteria.ERROR_TEXT;
      }
      return "";
    },
    blockByCFSError(code) {
      if (this.project.UF_IS_ALL_ZAIM_PR) {
        return true;
      }
      if (code !== "poruchitelstva-phis-face") {
        return false;
      }
      return this.isPhisFaceCFSBlocked;
    },
    // Очистка поручительства физлиц при блокировке по критериям финансовой
    // устойчивости: заблокированные поля не должны сохранять ранее введённые
    // название и объём обеспечения.
    clearPhisFaceCoverIfBlocked() {
      if (!this.loaded || !this.isPhisFaceCFSBlocked) {
        return;
      }
      let dirs = this.getProcurings().filter(function(dir) {
        return dir.CODE === "poruchitelstva-phis-face";
      });
      dirs.forEach(function(dir) {
        let items = this.project.MAIN_COVER.items[dir.ID];
        if (!items) {
          return;
        }
        items.forEach(function(item) {
          item.UF_JUR_FACE = "";
          item.UF_OBJEM_VALUE = 0;
          item.UF_OBJEM_DISCONT_VAL = 0;
          item.UF_HAVINGS = "";
        });
      }, this);
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID == id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    },
    addProcItem(id, dir) {
      let name =
        dir.CODE === "poruchitelstvo_international_financial_organizations"
          ? "Евразийский Банк Развития"
          : "";
      this.project.MAIN_COVER.items[id].push({
        UF_HAVINGS: "",
        UF_JUR_FACE: name,
        UF_MAIN_COVER_ID: id,
        UF_OBJEM_DISCONT_VAL: 0,
        UF_OBJEM_VALUE: 0,
        UF_PROJECT_ID: this.project.ID
      });
    },
    // "Наименование имущества" — текстовое поле, но бэк отдает 0 как значение
    // по умолчанию (ProjectMainCoverModel), поэтому чистим его перед показом
    clearDefaultMainCoverHavings() {
      Object.keys(this.project.MAIN_COVER.items).forEach(function(coverId) {
        this.project.MAIN_COVER.items[coverId].forEach(function(item) {
          if (item.UF_HAVINGS === 0 || item.UF_HAVINGS === "0") {
            Vue.set(item, "UF_HAVINGS", "");
          }
        });
      }, this);
    },
    addDopProcItem(id) {
      this.project.DOP_COVER.items[id].push({
        UF_DOP_COVER_ID: id,
        UF_HAVINGS: "",
        UF_JUR_FACE: "",
        UF_OBJEM_DISCONT_VAL: 0,
        UF_OBJEM_VALUE: 0,
        UF_PROJECT_ID: this.project.ID
      });
    },
    addZalogItem(id) {
      this.project.ZALOG.items[id].push({
        UF_HAVINGS: "",
        UF_JUR_FACE: "",
        UF_NAME_FACE_ZALOG: "",
        UF_OBJEM_DISCONT_VAL: 0,
        UF_OBJEM_VALUE: 0,
        UF_PROJECT_ID: this.project.ID,
        UF_TYPE_FACE_ZL_ID: null,
        UF_VID_BONDS_ID: null,
        UF_VID_TR_ID: null,
        UF_ZALOG_ID: id
      });
    },
    getProcurings() {
      let pr = [];
      this.project.MAIN_COVER.MAIN_COVER_ID.forEach(function(id) {
        this.directory.procuring.forEach(function(item) {
          if (item.ID === id) {
            pr.push(item);
          }
        });
      }, this);
      return pr;
    },
    deleteProcuring(id, index) {
      this.project.MAIN_COVER.items[id].splice(index, 1);
    },
    deleteZalog(id, index) {
      this.project.ZALOG.items[id].splice(index, 1);
    },
    clearRowZalog(item) {
      item.UF_JUR_FACE = "";
      item.UF_OBJEM_VALUE = 0;
      item.UF_OBJEM_DISCONT_VAL = 0;
      item.UF_VID_TR_ID = "";
      item.UF_TYPE_FACE_ZL_ID = "";
      item.UF_NAME_FACE_ZALOG = "";
      item.UF_VID_BONDS_ID = "";
      item.UF_HAVINGS = "";
    },
    clearRowDopZalog(item) {
      item.UF_JUR_FACE = "";
      item.UF_OBJEM_VALUE = 0;
      item.UF_OBJEM_DISCONT_VAL = 0;
      item.UF_HAVINGS = "";
    },
    deleteDopZalog(id, index) {
      this.project.DOP_COVER.items[id].splice(index, 1);
    },
    calcFirstSumZalogi() {
      if (!this.loaded) return 0;
      let sum = 0;
      if (
        this.project.ZALOG &&
        this.project.ZALOG.ZALOG_ID &&
        this.project.ZALOG.ZALOG_ID !== undefined
      ) {
        this.project.ZALOG.ZALOG_ID.forEach(function(id) {
          if (
            this.project.ZALOG.items &&
            this.project.ZALOG.items[id] &&
            this.project.ZALOG.items[id] !== undefined
          ) {
            this.project.ZALOG.items[id].forEach(function(item) {
              if (item.UF_OBJEM_VALUE > 0) {
                sum += parseInt(item.UF_OBJEM_VALUE);
              }
            });
          }
        }, this);
      }
      return sum;
    },
    calcFirstSum() {
      if (!this.loaded) return 0;
      let sum = 0;
      if (
        this.project.MAIN_COVER &&
        this.project.MAIN_COVER.MAIN_COVER_ID &&
        this.project.MAIN_COVER.MAIN_COVER_ID !== undefined
      ) {
        this.project.MAIN_COVER.MAIN_COVER_ID.forEach(function(id) {
          if (this.project.MAIN_COVER.items[id]) {
            this.project.MAIN_COVER.items[id].forEach(function(item) {
              if (item.UF_OBJEM_VALUE > 0) {
                sum += parseInt(item.UF_OBJEM_VALUE);
              }
            });
          }
        }, this);
      }
      if (this.project.ZALOG) {
        this.project.ZALOG.ZALOG_ID.forEach(function(id) {
          if (this.project.ZALOG.items[id]) {
            this.project.ZALOG.items[id].forEach(function(item) {
              this.directory.tree_zalogi.forEach(function(zl) {
                zl.CHILD.forEach(function(child) {
                  if (child.CODE !== "transport2" && child.ID === id) {
                    if (item.UF_OBJEM_VALUE > 0) {
                      sum += parseInt(item.UF_OBJEM_VALUE);
                    }
                  }
                }, this);
              }, this);
            }, this);
          }
        }, this);
      }
      return sum;
    },
    calcDopSum() {
      if (!this.loaded) return 0;
      let sum = 0;
      this.directory.dop_procuring.forEach(function(pr) {
        if (this.project.DOP_COVER.items[pr.ID] !== undefined) {
          this.project.DOP_COVER.items[pr.ID].forEach(function(item) {
            if (item.UF_OBJEM_VALUE > 0) {
              sum += parseInt(item.UF_OBJEM_VALUE);
            }
          });
        }
      }, this);
      return sum;
    },
    calcDopSumDiscont() {
      if (!this.loaded) return 0;
      let sum = 0;
      this.directory.dop_procuring.forEach(function(pr) {
        if (this.project.DOP_COVER.items[pr.ID] !== undefined) {
          this.project.DOP_COVER.items[pr.ID].forEach(function(item) {
            if (item.UF_OBJEM_DISCONT_VAL > 0) {
              sum += parseInt(item.UF_OBJEM_DISCONT_VAL);
            }
          });
        }
      }, this);
      return sum;
    },
    calcFirstSumTransport() {
      if (!this.loaded) return 0;
      let sum = 0;
      this.directory.tree_zalogi.forEach(function(item) {
        item.CHILD.forEach(function(child) {
          if (child.CODE === "transport2") {
            if (
              this.project.ZALOG.items &&
              this.project.ZALOG.items[child.ID] &&
              this.project.ZALOG.items[child.ID] !== undefined
            ) {
              this.project.ZALOG.items[child.ID].forEach(function(item) {
                if (item.UF_OBJEM_VALUE > 0) {
                  sum += parseInt(item.UF_OBJEM_VALUE);
                }
              });
            }
          }
        }, this);
      }, this);
      return sum;
    },
    calcFirstSumZalogiDiscount() {
      if (!this.loaded) return 0;
      let sum = 0;
      if (
        this.project.ZALOG.ZALOG_ID &&
        this.project.ZALOG.ZALOG_ID &&
        this.project.ZALOG.ZALOG_ID !== undefined
      ) {
        this.project.ZALOG.ZALOG_ID.forEach(function(id) {
          if (
            this.project.ZALOG.items &&
            this.project.ZALOG.items[id] &&
            this.project.ZALOG.items[id] !== undefined
          ) {
            this.project.ZALOG.items[id].forEach(function(item) {
              if (item.UF_OBJEM_DISCONT_VAL > 0) {
                sum += parseInt(item.UF_OBJEM_DISCONT_VAL);
              }
            });
          }
        }, this);
      }
      return sum;
    },
    calcFirstSumDiscount() {
      if (!this.loaded) return 0;
      let sum = 0;
      this.project.MAIN_COVER.MAIN_COVER_ID.forEach(function(id) {
        if (
          this.project.MAIN_COVER.items &&
          this.project.MAIN_COVER.items[id] &&
          this.project.MAIN_COVER.items[id] !== undefined
        ) {
          this.project.MAIN_COVER.items[id].forEach(function(item) {
            if (item.UF_OBJEM_DISCONT_VAL > 0) {
              sum += parseInt(item.UF_OBJEM_DISCONT_VAL);
            }
          });
        }
      }, this);
      this.project.ZALOG.ZALOG_ID.forEach(function(id) {
        if (this.project.ZALOG.items[id]) {
          this.project.ZALOG.items[id].forEach(function(item) {
            this.directory.tree_zalogi.forEach(function(zl) {
              zl.CHILD.forEach(function(child) {
                if (child.CODE !== "transport2" && child.ID === id) {
                  if (item.UF_OBJEM_VALUE > 0) {
                    sum += parseInt(item.UF_OBJEM_DISCONT_VAL);
                  }
                }
              }, this);
            }, this);
          }, this);
        }
      }, this);

      return sum;
    },
    calcFirstSumDiscountTransport() {
      if (!this.loaded) return 0;
      let sum = 0;
      this.directory.tree_zalogi.forEach(function(item) {
        item.CHILD.forEach(function(child) {
          if (child.CODE === "transport2") {
            if (
              this.project.ZALOG.items &&
              this.project.ZALOG.items[child.ID] &&
              this.project.ZALOG.items[child.ID] !== undefined
            ) {
              this.project.ZALOG.items[child.ID].forEach(function(item) {
                if (item.UF_OBJEM_DISCONT_VAL > 0) {
                  sum += parseInt(item.UF_OBJEM_DISCONT_VAL);
                }
              });
            }
          }
        }, this);
      }, this);
      return sum;
    },
    getZalogi() {
      let pr = [];
      let k = 0;
      this.directory.tree_zalogi.forEach(function(item) {
        let j = 0;
        item.CHILD.forEach(function(child) {
          if (child.CODE !== "transport2") {
            if (
              this.project.ZALOG.ZALOG_ID &&
              this.project.ZALOG.ZALOG_ID !== undefined
            ) {
              this.project.ZALOG.ZALOG_ID.forEach(function(id) {
                if (id == child.ID) {
                  if (item.CHILD.length == 1) {
                    k++;
                    child.INDEX = "10." + k;
                    child.IS_MULTI = false;
                  } else {
                    if (j === 0) {
                      k++;
                      item.INDEX = "10." + k;
                      item.IS_ZG = true;
                      pr.push(item);
                    }
                    j++;
                    child.IS_ZG = false;
                    child.IS_MULTI = true;
                    child.INDEX = "10." + k + "." + j;
                  }
                  pr.push(child);
                }
              });
            }
          }
        }, this);
      }, this);
      return pr;
    },
    getZalogiK() {
      let pr = [];
      let k = 0;
      this.directory.tree_zalogi.forEach(function(item) {
        let j = 0;
        item.CHILD.forEach(function(child) {
          this.project.ZALOG.ZALOG_ID.forEach(function(id) {
            if (id == child.ID) {
              if (item.CHILD.length == 1) {
                k++;
                child.INDEX = "10." + k;
                child.IS_MULTI = false;
              } else {
                if (j === 0) {
                  k++;
                  item.INDEX = "10." + k;
                  item.IS_ZG = true;
                  pr.push(item);
                }
                j++;
                child.IS_ZG = false;
                child.IS_MULTI = true;
                child.INDEX = "10." + k + "." + j;
              }
              pr.push(child);
            }
          });
        }, this);
      }, this);
      return k;
    },
    getZalogTransport() {
      let pr = [];
      let k = this.getZalogiK();
      k++;
      this.directory.tree_zalogi.forEach(function(item) {
        item.CHILD.forEach(function(child) {
          if (child.CODE === "transport2") {
            child.INDEX = "10." + k;
            pr.push(child);
          }
        });
      });
      return pr;
    },
    getProcuringItems(id) {
      return this.project.MAIN_COVER.items[id];
    },
    showFaceZalogName(id) {
      let t = this.directory.type_face_zalog.filter(c => c.ID === id);
      if (t.length > 0 && t[0].IS_SET_NAME == 1) {
        return true;
      }
      return false;
    },
    calcMainCoverDiscont(id, i, discont) {
      if (discont == 0) {
        Vue.set(
          this.project.MAIN_COVER.items[id][i],
          "UF_OBJEM_DISCONT_VAL",
          this.project.MAIN_COVER.items[id][i].UF_OBJEM_VALUE
        );
        return;
      }
      if (this.project.MAIN_COVER.items[id][i].UF_OBJEM_VALUE == 0) {
        Vue.set(
          this.project.MAIN_COVER.items[id][i],
          "UF_OBJEM_DISCONT_VAL",
          this.project.MAIN_COVER.items[id][i].UF_OBJEM_VALUE
        );
        return;
      }

      let v = this.project.MAIN_COVER.items[id][i].UF_OBJEM_VALUE / 100;
      discont = 100 - discont;
      Vue.set(
        this.project.MAIN_COVER.items[id][i],
        "UF_OBJEM_DISCONT_VAL",
        (v * discont).toFixed(0)
      );
    },
    calcDopCoverDiscont(id, i, discont) {
      if (discont == 0) {
        Vue.set(
          this.project.DOP_COVER.items[id][i],
          "UF_OBJEM_DISCONT_VAL",
          this.project.DOP_COVER.items[id][i].UF_OBJEM_VALUE
        );
        return;
      }
      if (this.project.DOP_COVER.items[id][i].UF_OBJEM_VALUE == 0) {
        Vue.set(
          this.project.DOP_COVER.items[id][i],
          "UF_OBJEM_DISCONT_VAL",
          this.project.DOP_COVER.items[id][i].UF_OBJEM_VALUE
        );
        return;
      }

      let v = this.project.DOP_COVER.items[id][i].UF_OBJEM_VALUE / 100;
      discont = 100 - discont;
      Vue.set(
        this.project.DOP_COVER.items[id][i],
        "UF_OBJEM_DISCONT_VAL",
        (v * discont).toFixed(0)
      );
    },
    getZalogDiscont(id) {
      let t = this.directory.sp_vid_oblegacii.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].DISCONT;
      }
      return 0;
    },
    calcMainZalogDiscont(id, i, discont) {
      this.removeZalogError(i);

      if (discont == 0) {
        Vue.set(
          this.project.ZALOG.items[id][i],
          "UF_OBJEM_DISCONT_VAL",
          this.project.ZALOG.items[id][i].UF_OBJEM_VALUE
        );
        return;
      }

      if (this.project.ZALOG.items[id][i].UF_OBJEM_VALUE === undefined) {
        this.project.ZALOG.items[id][i].UF_OBJEM_VALUE = 0;
      }

      if (this.project.ZALOG.items[id][i].UF_OBJEM_VALUE == 0) {
        Vue.set(
          this.project.ZALOG.items[id][i],
          "UF_OBJEM_DISCONT_VAL",
          this.project.ZALOG.items[id][i].UF_OBJEM_VALUE
        );
        return;
      }

      let v = this.project.ZALOG.items[id][i].UF_OBJEM_VALUE / 100;
      discont = 100 - discont;
      Vue.set(
        this.project.ZALOG.items[id][i],
        "UF_OBJEM_DISCONT_VAL",
        (v * discont).toFixed(0)
      );
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    hasMainCoverError(id, field) {
      if (typeof this.$parent.mainCoverErrors[id] !== "undefined") {
        if (typeof this.$parent.mainCoverErrors[id][field] !== "undefined") {
          return true;
        }
      }
      return false;
    },
    removeMainCoverError(id) {
      if (typeof this.$parent.mainCoverErrors[id] !== "undefined") {
        Vue.delete(this.$parent.mainCoverErrors, id);
      }
      return false;
    },
    hasZalogError(id, field) {
      if (typeof this.$parent.zalogErrors[id] !== "undefined") {
        if (typeof this.$parent.zalogErrors[id][field] !== "undefined") {
          return true;
        }
      }
      return false;
    },
    removeZalogError(id) {
      if (typeof this.$parent.zalogErrors[id] !== "undefined") {
        Vue.delete(this.$parent.zalogErrors, id);
      }
      return false;
    }
  },
  watch: {
    isPhisFaceCFSBlocked() {
      this.clearPhisFaceCoverIfBlocked();
    },
    loaded() {
      this.clearPhisFaceCoverIfBlocked();
    }
  },
  computed: {
    // 55081. Несоответствие критериям финансовой устойчивости. Считается
    // реактивно, чтобы блокировка срабатывала и при открытии шага, а не только
    // при правке выручки и долга.
    isErrorFinStability() {
      let finCrt1 = false;
      let finCrt2 = false;

      this.directory.sp_criteria_financial_stability.forEach(function(
        criteria
      ) {
        this.project.CRITERIA_FINANCIAL_STABILITY.items.forEach(function(item) {
          if (
            criteria.CODE == "vurychka_old_year" &&
            criteria.ID === item.UF_CRT_FINANCIAL_ID
          ) {
            if (item.UF_CRT_FINANCIAL_TTL < 5) {
              finCrt1 = true;
            }
          }

          if (
            criteria.CODE == "dolg_old_4_month" &&
            criteria.ID === item.UF_CRT_FINANCIAL_ID
          ) {
            if (item.UF_CRT_FINANCIAL_TTL > 6) {
              finCrt2 = true;
            }
          }
        }, this);
      },
      this);

      return (finCrt1 || finCrt2) && !!this.project.UF_IS_NOT_NEGATIVE;
    },
    isPhisFaceCFSBlocked() {
      if (!this.project.UF_IS_NOT_NEGATIVE || this.isErrorFinStability) {
        return true;
      }
      let r = false;
      this.directory.sp_criteria_financial_stability.forEach(function(
        criteria
      ) {
        this.project.CRITERIA_FINANCIAL_STABILITY.items.forEach(function(item) {
          if (
            criteria.CODE != "dolg_old_4_month" &&
            criteria.ID === item.UF_CRT_FINANCIAL_ID
          ) {
            if (this.showCFSError(item, criteria)) {
              r = true;
            }
          }
        }, this);
      },
      this);
      return r;
    },
    okpoShift() {
      return this.project.UF_SETTING &&
        this.project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1
        ? 1
        : 0;
    },
    mobOkpdShift() {
      return this.project.UF_SETTING &&
        this.project.UF_SETTING.IS_MOBILIZATION_VIEW_OKPD == 1
        ? 2
        : 0;
    },
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
